module.exports = __webpack_public_path__ + "img/ah02.32740a23.jpg";